import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  const linkClass = 'text-slate-500 hover:text-brand-blue transition-colors';
  return <footer className="bg-white border-t border-slate-200 pt-16 pb-8" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-97">
          <div className="lg:col-span-2" data-id="element-98">
            <Link to="/" className="inline-block mb-4" aria-label="Akios — Think bold. Build brilliant." data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/dPy3VAvV5Y6dyUnP324PQk/Logo_Social.png" alt="Akios" className="h-14 w-auto object-contain" data-id="element-100" />
            </Link>
            <p className="text-slate-500 mb-6 max-w-sm" data-id="element-101">
              Building the future of digital business with intelligent platforms
              and modern engineering.
            </p>
            <div className="flex gap-4" data-id="element-102">
              <a href="#" aria-label="Twitter" className="text-slate-400 hover:text-brand-blue transition-colors" data-id="element-103">
                <Twitter className="w-5 h-5" data-id="element-104" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-slate-400 hover:text-brand-blue transition-colors" data-id="element-105">
                <Linkedin className="w-5 h-5" data-id="element-106" />
              </a>
              <a href="#" aria-label="GitHub" className="text-slate-400 hover:text-brand-blue transition-colors" data-id="element-107">
                <Github className="w-5 h-5" data-id="element-108" />
              </a>
            </div>
          </div>

          <div data-id="element-109">
            <h4 className="font-bold text-slate-900 mb-4" data-id="element-110">Product</h4>
            <ul className="space-y-3" data-id="element-111">
              <li data-id="element-112">
                <Link to="/" className={linkClass} data-id="element-113">
                  Akios BOS
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/#features" className={linkClass} data-id="element-115">
                  Features
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/#pricing" className={linkClass} data-id="element-117">
                  Pricing
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/changelog" className={linkClass} data-id="element-119">
                  Changelog
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-120">
            <h4 className="font-bold text-slate-900 mb-4" data-id="element-121">Services</h4>
            <ul className="space-y-3" data-id="element-122">
              <li data-id="element-123">
                <Link to="/services/creative-experiences" className={linkClass} data-id="element-124">
                  Creative Experiences
                </Link>
              </li>
              <li data-id="element-125">
                <Link to="/services/saas-growth" className={linkClass} data-id="element-126">
                  SaaS Growth
                </Link>
              </li>
              <li data-id="element-127">
                <Link to="/services/data-analytics" className={linkClass} data-id="element-128">
                  Data Analytics
                </Link>
              </li>
              <li data-id="element-129">
                <Link to="/services/product-engineering" className={linkClass} data-id="element-130">
                  Engineering
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-131">
            <h4 className="font-bold text-slate-900 mb-4" data-id="element-132">Company</h4>
            <ul className="space-y-3" data-id="element-133">
              <li data-id="element-134">
                <Link to="/about" className={linkClass} data-id="element-135">
                  About Us
                </Link>
              </li>
              <li data-id="element-136">
                <Link to="/contact" className={linkClass} data-id="element-137">
                  Contact
                </Link>
              </li>
              <li data-id="element-138">
                <Link to="/careers" className={linkClass} data-id="element-139">
                  Careers
                </Link>
              </li>
              <li data-id="element-140">
                <Link to="/legal" className={linkClass} data-id="element-141">
                  Legal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-142">
          <p className="text-slate-400 text-sm" data-id="element-143">
            © 2026 Akios Edge Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm" data-id="element-144">
            <Link to="/privacy" className="text-slate-400 hover:text-slate-600" data-id="element-145">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-slate-400 hover:text-slate-600" data-id="element-146">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}